
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Clock, Film } from "lucide-react";

interface VideoProps {
  video: {
    title: string;
    description: string;
    video_id: string;
    date: string;
    tags: string[];
  };
}

const VideoCard = ({ video }: VideoProps) => (
  <Card className="mb-4 overflow-hidden hover:shadow-md transition-shadow">
    <CardHeader className="pb-2">
      <div className="flex justify-between items-start">
        <div>
          <CardTitle className="text-lg text-foreground">{video.title}</CardTitle>
          <CardDescription className="text-sm text-muted-foreground">{video.description}</CardDescription>
        </div>
        <Badge variant="secondary" className="text-xs">
          <Film size={14} className="mr-1" />
          Video
        </Badge>
      </div>
    </CardHeader>
    <CardContent>
      <div className="aspect-video mb-3">
        <iframe 
          width="100%" 
          height="100%" 
          src={`https://www.youtube.com/embed/${video.video_id}`}
          title={video.title}
          frameBorder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
          allowFullScreen
        ></iframe>
      </div>
      <div className="flex flex-wrap gap-2 mt-2">
        {video.tags.map((tag: string, i: number) => (
          <Badge key={i} variant="outline" className="text-xs">
            {tag}
          </Badge>
        ))}
      </div>
      <div className="mt-3 text-sm text-muted-foreground flex items-center">
        <Clock size={14} className="mr-1" />
        {video.date}
      </div>
    </CardContent>
  </Card>
);

export default VideoCard;
